import { ActualityHqDataRows } from '@warebee/shared/dataset-queries';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Virtuoso } from 'react-virtuoso';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { actualitySelectedEvent } from '../store/actuality.hq.state';
import { feedDisplayOptionAtom } from '../store/feed.state';
import FeedActivityEventDetails from './FeedActivityEventDetails';

export type ActualityEventsListProps = {
  events: ActualityHqDataRows;
};

const ActualityEventsList: React.FC<ActualityEventsListProps> = props => {
  const { t } = useTranslation('feed');
  const [feedDisplayOption, setFeedDisplayOption] = useRecoilState(
    feedDisplayOptionAtom,
  );
  const setSelectedEvent = useSetRecoilState(actualitySelectedEvent);

  // Ensure events is always an array to prevent undefined errors
  const events = Array.isArray(props.events) ? props.events : [];
  const sortedEvents = _.orderBy(events, ['eventEndTimeMs'], ['asc']);
  const shouldUseVirtuoso = sortedEvents.length > 100;
  return (
    <div
      data-component="ActualityEventseList"
      className="flex h-full min-h-0 flex-1 flex-col gap-0.5 overflow-hidden"
    >
      {shouldUseVirtuoso ? (
        <div
          data-component="ActualityEventsListVirtuoso"
          className="flex h-[100vh] flex-col gap-0.5 overflow-hidden"
        >
          <Virtuoso
            style={{ height: '100%' }}
            data={sortedEvents}
            itemContent={(index, item) => {
              return (
                <>
                  <FeedActivityEventDetails
                    key={`feed-event-details-${item.eventId}`}
                    event={item as any}
                    index={index}
                    onClick={() => setSelectedEvent(item)}
                  />
                </>
              );
            }}
            components={{
              List: React.forwardRef((props, ref) => (
                <div
                  data-component="ActualityEventsListVirtuosoEvent"
                  ref={ref}
                  {...props}
                  className="h-full min-h-0 flex-1"
                />
              )),
            }}
          />
        </div>
      ) : (
        <div
          data-component="ActualityEventsList"
          className="flex-1 overflow-y-auto overflow-x-hidden"
        >
          {sortedEvents.map((item, index) => (
            <FeedActivityEventDetails
              key={`feed-event-details-${item.eventId}`}
              event={item as any}
              index={index}
              onClick={() => setSelectedEvent(item)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ActualityEventsList;
